/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ConfirmPassword.css";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class ConfirmPassword extends Component {
  render() {
    //  const color = this.props.location.state.color;
    const languageObj = this.props.languageObj;
    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const iconStyle = {
      background: "#" + this.props.location.state.color.buttonColor,
    };

    const textStyle = {
      color: "#" + this.props.location.state.color.buttonColor,
    };

    const btnStyle = {
      background: "#" + this.props.location.state.color.buttonColor,
      color: "#" + this.props.location.state.color.headerColor,
    };

    return (
      <div className="ConfirmPassword-view">
        <div className="ConfirmPassword-main" style={backgroundOverrideStyle}>
          <div className="ConfirmPassword-container">
            <div className="ConfirmPassword-tick" style={iconStyle}></div>
            <div className="ConfirmPassword-tickText" style={textStyle}>
              {languageObj.tickText}
            </div>

            <Link to="/">
              <div className="ConfirmPassword-nextBtn" style={btnStyle}>
                {languageObj.nextBtn}
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
ConfirmPassword.propTypes = {
  logout: PropTypes.func,
  languageObj: PropTypes.object,
};
export default ConfirmPassword;
